import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import {
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Paper,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Autocomplete,
  TextField,
  DialogActions,
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Pagination,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "react-select";
import { tableCellClasses } from "@mui/material/TableCell";
import Axios from "axios";
import Sidebar from "../../sidebar/sidebar";
import { companylogo } from "../../../assets/images";
import { BaseUrl } from "../../../Environment";
import { DateRange, Person } from "@mui/icons-material";
import { getSecureItem } from "../../../utilsFunctions";
import PdfReportCA from "./PdfReportCA";
import { getCompanyProfile } from "../../../api/index";
import excel from '../../../assets/images/excel.svg';
import pdf from '../../../assets/images/pdf.svg';
import { Workbook } from "react-excel-workbook";

const moment = extendMoment(originalMoment);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e1f0fa",
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    cursor: "pointer",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const loanTableHeader = {
  loanId: "LoanId",
  firstName: "Borrower",
  loanAmount: "Lent",
  totalCollectionAmount: "Collected",
  totalPenaltyApplied: "Penalty",
  balanceAmount: "Balance",
  pendingDues: "Remaining Dues",
};

const collectionTableHeader = {
  srNo: "Sr. No.",
  dueDate: "Due Date",
  collectedDate: "Collected Date",
  openingBalance: "Opening Balance",
  Installment: "Installment Amount",
  collectionAmount: "Collected",
  closingBalance: "Closing Balance",
  PenaltyApplied: "Penalty",
  collectorId: "Collection Agent",
};

const CollectorWiseReport = () => {
  const loggedinUser = getSecureItem("loggedinUser");
  const columnWidths = [
    { wch: 200 },
    { wch: 200 },
    { wch: 250 }
  ]

  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [companyData, setCompanyData] = useState({});
  const [reportTableData, setReportTableData] = useState([]);
  const [loanClnData, setLoanClnData] = useState([]);
  const [showFirstModal, setShowFirstModal] = useState(true);
  const [showDateRange, setShowDateRange] = useState(false);
  const [cAgentData, setCAgentData] = useState([]);
  const [collectorId, setCollectorId] = useState(null);
  const [loanStatus, setLoanStatus] = useState("Open");
  const [loanPaymentStatus, setLoanPaymentStatus] = useState("All");
  const [loanTenure, setLoanTenure] = useState("All");
  const [blockDatas, setBlockDatas] = useState({});
  const [loanId, setLoanId] = useState("");
  const [selectedBorrower, setSelectedBorrower] = useState("");
  const [companyName, setCompanyName] = useState(
    loggedinUser?.firstName + " " + loggedinUser?.lastName
  );
  const [currency, setCurrency] = useState(getSecureItem("country")?.symbol);
  const [userType, setUserType] = useState(loggedinUser?.userType);
  const [collectionModal, setCollectionModal] = useState(false);

  function processLoanData(data) {
    const result = {};

    data.forEach((entry) => {
      const loanIDs = entry.loanId;
      const customer = entry.customer;
      const collectorId = entry.collectorId;
      const loanCollections = entry?.loanCollections
        ?.filter((data) => data?.collectionStatus != null)
        ?.map((data) => ({
          dueDate: data?.dueDate,
          collectedDate: data?.collectedDate,
          openingBalance: parseFloat(data?.openingBalance),
          Installment: parseFloat(data?.Installment),
          collectionAmount: parseFloat(data?.collectionAmount),
          closingBalance: parseFloat(data?.closingBalance),
          PenaltyApplied: parseFloat(data?.PenaltyApplied),
          collectorId: data?.collectorId,
        }));

      if (!result[loanIDs]) {
        result[loanIDs] = {
          loanId: loanIDs,
          customer,
          collectorId,
          loanTenureType: entry?.loanTenureType,
          loanTenureVal: entry?.loanTenure,
          loanAmount: parseFloat(entry?.totalAmountToCollect),
          loanStatus: entry?.loanStatus,
          loanPaymentStatus: entry?.loanPaymentStatus,
          collectedDate: entry?.collectedDate,
          createdAt: entry?.createdAt,
          startDate: entry?.startDate,
          totalCollectionAmount: 0,
          totalPenaltyApplied: 0,
          pendingDues: 0,
          balanceAmount: 0,
          loanCollections,
        };
      }

      const pendingDuesCollections = entry?.loanCollections
        ?.filter((data) => data?.collectionStatus == null)

      if (loanCollections) {
        result[loanIDs].pendingDues = pendingDuesCollections?.length;
        result[loanIDs].totalCollectionAmount = loanCollections.reduce(
          (total, collection) => {
            return total + parseFloat(collection.collectionAmount);
          },
          0
        );
        result[loanIDs].totalPenaltyApplied = loanCollections.reduce(
          (total, collection) => {
            return total + parseFloat(collection.PenaltyApplied ?? 0);
          },
          0
        );
        result[loanIDs].balanceAmount =
          parseFloat(loanCollections?.slice(-1)[0]?.closingBalance) ||
          parseFloat(entry?.totalAmountToCollect);
      }
    });

    return Object.values(result);
  }

  function processBlockData(data) {
    const result = {};

    data.forEach((entry) => {
      const loanIDs = entry.loanId;
      const loanCollections = entry?.loanCollections?.filter(
        (data) => data?.collectionStatus != null
      );

      if (!result[loanIDs]) {
        result[loanIDs] = {
          loanId: loanIDs,
          loanAmount: parseFloat(entry?.totalAmountToCollect),
          totalCollectionAmount: 0,
          totalPenaltyApplied: 0,
          balanceAmount: 0,
        };
      }

      const pendingDuesCollections = entry?.loanCollections
        ?.filter((data) => data?.collectionStatus == null)

      if (loanCollections) {
        result[loanIDs].pendingDues = pendingDuesCollections?.length;
        result[loanIDs].totalCollectionAmount = loanCollections.reduce(
          (total, collection) => {
            return total + parseFloat(collection.collectionAmount);
          },
          0
        );
        result[loanIDs].totalPenaltyApplied = loanCollections.reduce(
          (total, collection) => {
            return total + parseFloat(collection.PenaltyApplied ?? 0);
          },
          0
        );
        result[loanIDs].balanceAmount =
          parseFloat(loanCollections?.slice(-1)[0]?.closingBalance) ||
          parseFloat(entry?.totalAmountToCollect);
      }
    });

    return Object.values(result);
  }


  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      setBranchData(branchData?.map(item => ({
        label: item.branchName,
        value: item.branchId
      })) || []);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const getLoansData = async () => {
    try {
      const token = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      // let userId = loggedinUser?.userId;

      const headers = {
        Authorization: "Bearer " + token,
      };

      const payLoad = {
        companyId,
        collectorId: collectorId?.value,
        loanPaymentStatus,
        loanStatus,
        loanTenureType: loanTenure,
        userType,
        ...(dateRange?.start && { startDateR: dateRange?.start }),
        ...(dateRange?.end && { endDateR: dateRange?.end }),
        branchId: selectedBranch?.value || null
      };

      const res = await Axios.post(
        `${BaseUrl}/loan/getCollectionAgentReport`,
        payLoad,
        {
          headers,
        }
      );

      const { data: rawData } = res;

      const loanData = processLoanData(rawData?.result);
      const blockData = processBlockData(rawData?.result);

      if (loanData?.length > 0) {
        setReportTableData(loanData);
      } else {
        setReportTableData([]);
      }
      setBlockDataFn(blockData);
    } catch (err) {
      console.error(err);
    }
  };

  const getAllUsers = async () => {
  try {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");
    const loggedinUser = getSecureItem("loggedinUser");
    const branchId = loggedinUser?.userType == "superAdmin" ? selectedBranch?.value || null : selectedBranch?.value || loggedinUser?.branchId || null;
    const res = await Axios.get(`${BaseUrl}/user/getAllUsers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        userName: "",
        companyId,
        branchId,
      },
    });

    const response = res?.data?.result || [];

    const filteredUsers =
      userType === "Collection Agent"
        ? response.filter(
            (item) => item?.userId === loggedinUser?.userId
          )
        : response;

    const cList = filteredUsers.map((item) => ({
      label: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
      value: item.userId,
    }));

    setCAgentData(cList);
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};
  const getCompany = async () => {
    try {
      const compData = await getCompanyProfile();
      const {
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        AddressStreet,
        AddressLandmark,
        AddressCity,
        AddressState,
        AddressPincode,
      } = compData;
      setCompanyData({
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        address: {
          AddressStreet,
          AddressLandmark,
          AddressCity,
          AddressState,
          AddressPincode,
        },
      });
      console.log({ compData });
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    getAllUsers();
    // console.log("selectedBranch?.value", selectedBranch);
  }, [selectedBranch]);

  useEffect(() => {
    if (collectorId?.value) {
      getLoansData();
    }
  }, [
    loanStatus,
    loanPaymentStatus,
    loanTenure,
    showFirstModal,
    showDateRange,
    collectorId
    // selectedBranch
  ]);

  const setBlockDataFn = (dataArr) => {
    const sumLoanAmt = dataArr?.reduce(
      (acc, value) => acc + parseFloat(value?.loanAmount),
      0
    );
    const sumCollectionAmt = dataArr?.reduce(
      (acc, value) => acc + parseFloat(value?.totalCollectionAmount),
      0
    );
    const sumPenaltyAmt = dataArr?.reduce(
      (acc, value) => acc + parseFloat(value?.totalPenaltyApplied),
      0
    );
    const sumBalanceAmt = dataArr?.reduce(
      (acc, value) => acc + parseFloat(value?.balanceAmount),
      0
    );

    setBlockDatas({
      sumLoanAmt,
      sumCollectionAmt,
      sumPenaltyAmt,
      sumBalanceAmt,
    });
  };

  const fourBlockData = [
    {
      value: blockDatas?.sumLoanAmt ?? 0,
      heading: "Total Loan Amt",
      currency: currency,
    },
    {
      value: blockDatas?.sumCollectionAmt ?? 0,
      heading: "Total Collected Amt",
      currency: currency,
    },
    {
      value: blockDatas?.sumPenaltyAmt ?? 0,
      heading: "Total Penalty Amt",
      currency: currency,
    },
    {
      value: blockDatas?.sumBalanceAmt ?? 0,
      heading: "Total Balance Amt",
      currency: currency,
    },
  ];

  const LoanStatusFilter = [
    { label: "Open", value: "Open" },
    { label: "Closed", value: "Closed" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Replanned", value: "Replaned" },
    { label: "All", value: "All" },
  ];

  const PaymentStatusFilter = [
    { label: "Due", value: "Due" },
    { label: "OverDue", value: "OverDue" },
    { label: "All", value: "All" },
  ];

  const SequenceFilter = [
    { value: "onetime", label: "Onetime" },
    { value: "daily", label: "Daily" },
    ...(getSecureItem("loggedinUserCompany") == 2891 ? [{label: 'Ten_Daily', value: 'ten_daily'}] : []),
    { value: "weekly", label: "Weekly" },
    { value: "biweekly", label: "Bi-Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "All", label: "All" },
  ];

  const handleChangeLoanStatus = (event, val) => {
    setLoanStatus(val);
  };

  const handleChangePaymentStatus = (event, val) => {
    setLoanPaymentStatus(val);
  };

  const handleChangeSequence = (event, val) => {
    setLoanTenure(val);
  };

  // Table sorting hooks and functions
  const [sortedData, setSortedData] = useState([]);
  const [sortedDataCln, setSortedDataCln] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // Handle sorting by a specific column
  const handleSortNew = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    if (reportTableData?.length > 0) {
      let sortedArray = [...reportTableData];

      if (sortConfig.key) {
        const aa = sortedArray?.sort((a, b) => {
          const aVal = a[sortConfig.key];
          const bVal = b[sortConfig.key];

          // Sorting logic for dates in 'DD/MM/YYYY' format
          if (sortConfig.key === "date") {
            const dateA = moment(aVal, "DD/MM/YYYY");
            const dateB = moment(bVal, "DD/MM/YYYY");
            return sortConfig.direction === "asc"
              ? +dateA - +dateB
              : +dateB - +dateA;
          }

          // Numeric sorting
          if (typeof aVal === "number" && typeof bVal === "number") {
            return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
          }

          // String sorting
          if (typeof aVal === "string" && typeof bVal === "string") {
            return sortConfig.direction === "asc"
              ? aVal?.localeCompare(bVal)
              : bVal?.localeCompare(aVal);
          }

          return 0;
        });
      }
      setSortedData(sortedArray);
    } else {
      setSortedData([]);
    }

    if (loanClnData?.length > 0) {
      let sortedArrayCln = [...loanClnData];

      if (sortConfig.key) {
        const aa = sortedArrayCln?.sort((a, b) => {
          const aVal = a[sortConfig.key];
          const bVal = b[sortConfig.key];

          // Sorting logic for dates in 'DD/MM/YYYY' format
          if (sortConfig.key === "date") {
            const dateA = moment(aVal, "DD/MM/YYYY");
            const dateB = moment(bVal, "DD/MM/YYYY");
            return sortConfig.direction === "asc"
              ? +dateA - +dateB
              : +dateB - +dateA;
          }

          // Numeric sorting
          if (typeof aVal === "number" && typeof bVal === "number") {
            return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
          }

          // String sorting
          if (typeof aVal === "string" && typeof bVal === "string") {
            return sortConfig.direction === "asc"
              ? aVal?.localeCompare(bVal)
              : bVal?.localeCompare(aVal);
          }

          return 0;
        });
      }
      setSortedDataCln(sortedArrayCln);
    } else {
      setSortedDataCln([]);
    }
  }, [sortConfig, reportTableData, loanClnData]);

  function getLabelByValue(searchValue) {
    const dataArray = cAgentData || [];
    const matchedItem = dataArray.find((item) => item.value == searchValue);
    return matchedItem ? matchedItem.label : null;
  }

  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: "73px", height: "100vh" }}>
        <Grid container direction={"column"}>
          <Grid item sx={{ backgroundColor: "#fff" }}>
            <div style={{ margin: 5 }}>
              <img src={companylogo} width={200} height={40} alt="logo" />
            </div>
          </Grid>
          <strong
            style={{
              textAlign: "center",
              fontFamily: "Lato",
              marginTop: 10,
              fontSize: 18,
            }}
          >
            Collection-Agent Wise Report
          </strong>
          <Grid item container paddingX={4} paddingY={2}>
            <Grid item xs={12} sm={12} md={3} lg={4} marginTop={2}>
              <ToggleButtonGroup
                color="primary"
                value={loanStatus}
                exclusive
                onChange={handleChangeLoanStatus}
                aria-label="Platform"
                size="small"
              >
                {LoanStatusFilter?.map((filter, i) => (
                  <ToggleButton key={i} value={filter?.value}>
                    {filter?.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={4} marginTop={2}>
              <ToggleButtonGroup
                color="primary"
                value={loanPaymentStatus}
                exclusive
                onChange={handleChangePaymentStatus}
                aria-label="Platform"
                size="small"
              >
                {PaymentStatusFilter?.map((filter, i) => (
                  <ToggleButton key={i} value={filter?.value}>
                    {filter?.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} marginTop={2}>
              <ToggleButtonGroup
                color="primary"
                value={loanTenure}
                exclusive
                onChange={handleChangeSequence}
                aria-label="Platform"
                size="small"
              >
                {SequenceFilter?.map((filter, i) => (
                  <ToggleButton key={i} value={filter?.value}>
                    {filter?.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
            <Grid
              className="assetmanagementpage"
              item
              xs={12}
              sm={12}
              md={3}
              lg={4}
              marginTop={2}
            >
              <Stack direction={"row"} gap={2}>
                <Button
                  variant="outlined"
                  className="muiCustomButton"
                  style={{ width: 40 }}
                  onClick={() => setShowDateRange(true)}
                  startIcon={<DateRange />}
                ></Button>
                <Button
                  variant="outlined"
                  className="muiCustomButton"
                  style={{ width: 250 }}
                  onClick={() => setShowFirstModal(true)}
                  startIcon={<Person />}
                >
                  Change Filter
                </Button>
              </Stack>
            </Grid>
            {/* <Grid item xs={12} md={4} marginTop={2}>
              <Select
                options={branchData}
                value={selectedBranch}
                onChange={(val) => setSelectedBranch(val)}
                placeholder="Select Branch"
              />
            </Grid> */}
          </Grid>
          <Grid item container paddingX={4} paddingY={2}>
            {fourBlockData?.map((data, i) => {
              return (
                <Grid key={i} item xs={12} sm={6} md={4} lg={3} marginTop={2}>
                  <Card
                    elevation={3}
                    sx={{
                      marginRight: 5,
                      minHeight: 130,
                      borderRadius: 3,
                      backgroundColor: "#fff",
                    }}
                  >
                    <CardHeader
                      title={
                        <div style={{ fontSize: 15 }}>{data?.heading}</div>
                      }
                    />
                    <CardContent>
                      <CardHeader
                        title={
                          <div style={{ fontSize: 20 }}>
                            {(data.value ? data.value : "0") +
                              (data.currency ? " " + data.currency : "")}
                          </div>
                        }
                      />
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          {loanId ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box paddingX={4} paddingY={2}>
                <p className="Fonts">NOTE: Click on record to see details</p>
              </Box>
              <Box paddingX={4} paddingY={2}>
                {/* <Button
                  onClick={() => 
                    PdfReportCA({
                      sortedData,
                      fourBlockData,
                      selectedBorrower,
                      dateRange,
                      loanStatus,
                      loanPaymentStatus,
                      loanTenure,
                      companyData
                    })
                  }
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: 5,
                    textDecoration: "none",
                  }}
                >
                  {"Download PDF Report"}
                </Button> */}
                <Stack direction={"row"} alignItems="center" gap={2}>
                  <p className="Fonts">Download Reports: </p>
                  <img src={pdf} alt="pdf" className="pdficon" onClick={() => 
                    PdfReportCA({
                      sortedData,
                      fourBlockData,
                      selectedBorrower,
                      dateRange,
                      loanStatus,
                      loanPaymentStatus,
                      loanTenure,
                      companyData
                    })} />
                  <Workbook filename="collection_agent_report.xlsx" element={<img src={excel} alt="excel" className="excelicon" />}>
                    <Workbook.Sheet
                      data={sortedData.map((item, index) => {
                        const borrowerName = `${item?.customer?.firstName ?? ""} ${item?.customer?.lastName ?? ""}`;
                        const custId = item?.customer?.cust_id ? ` (${item.customer.cust_id})` : "";

                        return {
                          loanId: item.loanId,
                          borrower: borrowerName + custId,
                          loanAmount: item.loanAmount,
                          clnAmount: item.totalCollectionAmount,
                          penalty: item.totalPenaltyApplied,
                          balanceAmt: item.balanceAmount,
                          pendingDues: item.pendingDues,
                          loanTenure: item.loanTenureVal,
                        };
                      })}
                      columsWidths={columnWidths}
                      name="Collection-Agent Report"
                    >
                      <Workbook.Column label="Loan ID" value="loanId" />
                      <Workbook.Column label="Borrower" value="borrower" />
                      <Workbook.Column label="Lent Amount" value="loanAmount" />
                      <Workbook.Column label="Collected Amount" value="clnAmount" />
                      <Workbook.Column label="Penalty Applied" value="penalty" />
                      <Workbook.Column label="Balance Amount" value="balanceAmt" />
                      <Workbook.Column label="Remaining Dues" value="pendingDues" />
                      <Workbook.Column label="Loan Tenure" value="loanTenure" />
                    </Workbook.Sheet>
                  </Workbook>
                </Stack>
              </Box>
            </div>
          )}

          <Grid item container paddingX={4} paddingY={2}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {Object.keys(loanTableHeader).map((property) => (
                      <StyledTableCell key={property}>
                        <TableSortLabel
                          active={sortConfig.key === property}
                          direction={
                            sortConfig.key === property
                              ? sortConfig.direction
                              : "asc"
                          }
                          onClick={() => handleSortNew(property)}
                        >
                          {loanTableHeader[property]}
                        </TableSortLabel>
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedData?.map((data, index) => (
                    <StyledTableRow
                      key={index}
                      onClick={() => {
                        setLoanId(data?.loanId);
                        setSelectedBorrower(
                          data?.customer?.firstName +
                            " " +
                            data?.customer?.lastName
                        );
                        setBlockDataFn([
                          {
                            loanAmount: parseFloat(data?.loanAmount),
                            totalCollectionAmount: data?.totalCollectionAmount,
                            totalPenaltyApplied: data?.totalPenaltyApplied,
                            balanceAmount: parseFloat(data?.balanceAmount),
                          },
                        ]);
                        setLoanClnData(data?.loanCollections);
                        setCollectionModal(true);
                      }}
                    >
                      <StyledTableCell>{data?.loanId}</StyledTableCell>
                      <StyledTableCell>
                        {
                          <Stack>
                            <div>
                              {data?.customer?.firstName +
                                " " +
                                data?.customer?.lastName}
                            </div>
                            {data?.customer?.cust_id ? (
                              <div>({data?.customer?.cust_id})</div>
                            ) : null}
                          </Stack>
                        }
                      </StyledTableCell>
                      <StyledTableCell>{data?.loanAmount}</StyledTableCell>
                      <StyledTableCell>
                        {data?.totalCollectionAmount}
                      </StyledTableCell>
                      <StyledTableCell>
                        {data?.totalPenaltyApplied || 0}
                      </StyledTableCell>
                      <StyledTableCell>{data?.balanceAmount}</StyledTableCell>
                      <StyledTableCell>{data?.pendingDues}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Dialog
          open={showFirstModal}
          onClose={() => setShowFirstModal(false)}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Collection-Agent Wise Report"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Choose the Collection-Agent from here.
            </DialogContentText>
            <Autocomplete
              disablePortal
              id="combo-box"
              options={branchData}
              value={selectedBranch}
              disabled={(loggedinUser?.company?.planId == 3) ? false : true}
              sx={{ marginTop: 2, width: 350 }}
              onChange={(event, newValue) => {
                setCollectorId("");
                setSelectedBranch(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField {...params} label="Select Branch" />
              )}
            />
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={cAgentData}
              value={collectorId}
              sx={{ marginTop: 2, width: 350 }}
              onChange={(event, newValue) => {
                // console.log({newValue});
                setCollectorId(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField {...params} label="Select Collection-Agent" />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => {
                setSelectedBranch(null);
                setCollectorId('');
                setReportTableData([]);
              }}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              onClick={() => setShowFirstModal(false)}
            >
              Show Report
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Dialog
        open={collectionModal}
        fullWidth={true}
        maxWidth="lg"
        onClose={() => {
          setLoanId("");
          setBlockDataFn(reportTableData);
          setCollectionModal(false);
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {`Loan Collection Table | Borrower's Name: ${selectedBorrower}, Loan ID: ${loanId}`}
        </DialogTitle>
        <DialogContent>
          <Grid item container paddingX={4} paddingY={2}>
            {fourBlockData?.map((data, i) => {
              return (
                <Grid key={i} item xs={12} sm={6} md={4} lg={3} marginTop={2}>
                  <Card
                    elevation={3}
                    sx={{
                      marginRight: 5,
                      minHeight: 130,
                      borderRadius: 3,
                      backgroundColor: "#fff",
                    }}
                  >
                    <CardHeader
                      title={
                        <div style={{ fontSize: 15 }}>{data?.heading}</div>
                      }
                    />
                    <CardContent>
                      <CardHeader
                        title={
                          <div style={{ fontSize: 20 }}>
                            {(data.value ? data.value : "0") +
                              (data.currency ? " " + data.currency : "")}
                          </div>
                        }
                      />
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
          {loanId ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {Object.keys(collectionTableHeader).map((property) => (
                      <StyledTableCell key={property}>
                        <TableSortLabel
                          active={sortConfig.key === property}
                          direction={
                            sortConfig.key === property
                              ? sortConfig.direction
                              : "asc"
                          }
                          onClick={() => handleSortNew(property)}
                        >
                          {collectionTableHeader[property]}
                        </TableSortLabel>
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedDataCln?.map((data, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>
                        {moment(data?.dueDate).format("DD/MM/YYYY")}
                      </StyledTableCell>
                      <StyledTableCell>
                        {moment(data?.collectedDate).format("DD/MM/YYYY")}
                      </StyledTableCell>
                      <StyledTableCell>{data?.openingBalance}</StyledTableCell>
                      <StyledTableCell>{data?.Installment}</StyledTableCell>
                      <StyledTableCell>
                        {data?.collectionAmount}
                      </StyledTableCell>
                      <StyledTableCell>{data?.closingBalance}</StyledTableCell>
                      <StyledTableCell>{data?.PenaltyApplied || 0}</StyledTableCell>
                      <StyledTableCell>
                        {getLabelByValue(data?.collectorId)}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setLoanId("");
              setBlockDataFn(reportTableData);
              setCollectionModal(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Date Range */}
      <Dialog
        open={showDateRange}
        onClose={() => setShowDateRange(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Date Range Picker"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Choose the date range from here.
          </DialogContentText>
          <DateRangePicker
            value={dateRange}
            onSelect={(value) => setDateRange(value)}
            singleDateRange={true}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setShowDateRange(false)}>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withNamespaces()(CollectorWiseReport);
